/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * If set, send a lightweight reminder email to the lecturer N hours before the session. Mutually exclusive with send_briefing: if send_briefing=True this field is ignored since the richer briefing email already covers the notification need.
 */
export type EventKindSendLecturerReminderHoursBefore = number | null;
